import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import Popup from "../popups/popup";
import { SmallPrimaryButton } from "@worthy-npm/clarity";
import { isMobile } from "helpers/ApplicationHelper";
import { getShipBackText } from "../item/shipBack/helpers";
import Divider from "@material-ui/core/Divider";

const btnStyle = {
  fontSize: "16px",
  background: "#2D5DEC",
  fontFamily: "Roboto",
  lineHeight: "30px",
  fontWeight: "400",
  width: "125px",
  height: "42px",
  borderRadius: "3px",
  marginBottom: "20px",
};

class PopupMoreDetailsShipbackOptions extends Popup {
  constructor(props) {
    super(props);
    this._hide = this._hide.bind(this);
  }

  static initPopup(props = {}) {
    props.stopAnimation ? props.stopAnimation() : null;
    Popup.initPopup.call(this, props);
  }

  title() {
    return (
      <>
        {getShipBackText("shippingOptionsModal::title")}
        <br />
        <div className="sub-title">
          {getShipBackText("shippingOptionsModal::subTitle")}
        </div>
      </>
    );
  }

  _onPopupClose() {
    if (this.props.stopAnimation) {
      this.props.stopAnimation();
    }
  }

  _hide() {
    super._hide();
  }

  content() {
    return (
      <div className={"more-details-popup"}>
        <div className={"popup-more-details-content modal-content"}>
          <Grid className={"more-details-popup-upper-divider"} xs={12}>
            <Divider light style={{ margin: "25px 0 25px" }} />
          </Grid>
          <p className={"more-details-popup-text"}>
            {getShipBackText("shippingOptionsModal::contentP1")}
          </p>
          <br />
          <p className={"more-details-popup-text"}>
            {getShipBackText("shippingOptionsModal::contentP2")}
          </p>
          <br />
          <p className={"more-details-popup-text"}>
            {getShipBackText("shippingOptionsModal::contentP3")}
          </p>
          <br />
          <p className={"more-details-popup-text"}>
            {getShipBackText("shippingOptionsModal::contentP4")}
          </p>

          <Grid className={"more-details-popup-bottom-divider"} xs={12}>
            <Divider light style={{ margin: "25px 0 25px" }} />
          </Grid>
        </div>

        <div className="more-details-btn-row">
          <SmallPrimaryButton
            overrideCSS={btnStyle}
            click={this._hide}
            text={getShipBackText("shippingOptionsModal::closeBtn")}
          />
        </div>
      </div>
    );
  }
}

PopupMoreDetailsShipbackOptions.defaultProps = {
  popupClassName:
    "popup-schedule-secure-shipment shipback shipBack--white-modal",
  single: true,
  modal: true,
  onPopupClose: function () {
    this._onPopupClose();
  },
};

export default PopupMoreDetailsShipbackOptions;
